import React from "react";
import { useParams } from "react-router-dom";
import { ProjectList } from "../helpers/ProjectList";
import GithubIcon from "@material-ui/icons/GitHub";
import "../styles/ProjectDisplay.css";

function ProjetoDisplay() {
  const { id } = useParams();
  const project = ProjectList[id];
  return (
    <div className="project">
      <h1> {project.name}</h1>
      <img src={project.image} alt="Apenas mais um projeto do payet" />
      <p>
        <b>Skills:</b> {project.skills}
      </p>
      <a
        href={`https://github.com/${project.perfil}/${project.link}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        <GithubIcon />
      </a>
    </div>
  );
}

export default ProjetoDisplay;
